import React, { useMemo } from "react";

import ShyftPassTemplate from "@/components/Templates/ShyftPassTemplate";

import HeroSection from "./HeroSection";
import WorkoutScheduleSection from "./WorkoutScheduleSection";
import RegisterFormSection from "./RegisterFormSection";
import FAQSection from "./FAQSection";

import { useAppSelector } from "@/hooks";

import mapShyftPassData from "./mapShyftPassData";
import { ShyftPassDataI } from "./shyftPassMaps";

const ShyftPass = () => {
  const { data, isLoading, success, error } =
    useAppSelector((state) => state.healthProgramV1) || {};

  let { shyftPassZoneList } = useAppSelector((state) => state.shyftPass) || {};

  const { hero, benefits, workoutSchedule, form, faqs } = useMemo(() => {
    if (!Object.keys(data)?.length)
      return {
        hero: {},
        benefits: {},
        workoutSchedule: {},
        form: {},
        faqs: {},
      } as ShyftPassDataI;
    return mapShyftPassData(data);
  }, [data]);

  return (
    <ShyftPassTemplate error={error}>
      <HeroSection {...hero} />
      <div className="shyft-pass-content-content-wrapper">
        <WorkoutScheduleSection {...workoutSchedule} isHomePage />
        <RegisterFormSection {...{ ...form, shyftPassZoneList }} />
        <FAQSection {...faqs} />
      </div>
    </ShyftPassTemplate>
  );
};

export default ShyftPass;
